
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LogApi, Log } from 'src/app/core/api.gen';
@Component({
  selector: 'eos-log-details',
  templateUrl: './log-details.component.html'

})
export class LogDetailsComponent implements OnInit {

  @Input() public logId: number;
  details: Log = new Log();
  constructor(public modal: NgbActiveModal, private logAPI: LogApi) {
  }

  ngOnInit() {
    this.getLogDetails();
  }

  getLogDetails() {
    this.logAPI.getLogListDetails(this.logId).subscribe(logDetails => {
      this.details = logDetails;
    });
  }

}

